const photos = [
  {
    alt: "réparation fenêtre PVC Strasbourg",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4f5ebbcb84a72fdd78cd48d354b38b1d.webp",
    seq: 701,
    w: 800,
    h: 600,
  },
  {
    alt: "mécanisme fenêtre PVC Bas-Rhin",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/ce40868f0334c840c1262eb6cbb1cf52.jpeg",
    seq: 702,
    w: 800,
    h: 600,
  },
  {
    alt: "crémone fenêtre PVC Schiltigheim",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/972d460947537c5df09774bda0ffb58f.jpeg",
    seq: 703,
    w: 800,
    h: 600,
  },
  {
    alt: "gond fenêtre PVC Haguenau",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4556278079676d5ae98b246f855d6da5.jpeg",
    seq: 704,
    w: 800,
    h: 600,
  },
  {
    alt: "poignée fenêtre PVC Illkirch",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/65a7cc3cb6b8e3ce4f320a786437b00f.jpeg",
    seq: 705,
    w: 800,
    h: 600,
  },
  {
    alt: "réglage fenêtre PVC Strasbourg centre",
    src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d4eb334fa6c3ec07d88434ab6f63fc88.jpeg",
    seq: 706,
    w: 800,
    h: 600,
  },
];

export default function Gallery() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-8 md:mb-10">
            Galerie photos — réparation fenêtre PVC
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="aspect-[4/3] rounded-2xl overflow-hidden border border-rose-200 bg-rose-50"
            >
              <img
                src={
                  photo.src
                    ? photo.src
                    : `https://readdy.ai/api/search-image?query=${encodeURIComponent(photo.prompt)}&width=${photo.w}&height=${photo.h}&seq=${photo.seq}&orientation=landscape`
                }
                alt={photo.alt}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}